import { makeAutoObservable } from 'mobx';
import API_URL from '../../config/ApiUrl';
import RootStore from '../RootStore/RootStore';
import axios from 'axios';
import BulkFileAccommodationStore from '../BulkImport/AccommodationImport';
import { ServerGridConfig } from '../../config/GridConfig';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { Notification } from '../../config/Global';
export default class AccommodationStore {
	list_data = null;
	agGrid = null;
	per_page = ServerGridConfig.options.paginationPageSize;
	accommodationDetail = null;
	merchantDetail = null;
	propertyDetail = null;
	roomCategoryDetail = null;
	searchValue = '';
	subscriptionList = [];
	merchantLookupList = [];
	subscriptionHistory = [];
	merchantAccomodation = [];
	roomcategorybyproperty = [];
	propertyImageDetails = [];
	roomCategoryImageDetails = [];
	roomCategoryLookup = [];
	roomCategoryEditData = null;

	constructor() {
		makeAutoObservable(this);
		this.rootStore = new RootStore();
		this.BulkFileAccommodation = new BulkFileAccommodationStore();
	}
	bulkImport = async (formData) => {
		return await axios
			.post(API_URL.ACCOMMODATION.BULKIMPORT, formData)
			.then(({ data }) => {
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};
	setupGrid = (params) => {
		this.agGrid = params;
		const { api } = params;
		let datasource = this.createDatasource(ServerGridConfig.options);
		api.setServerSideDatasource(datasource);
	};
	createDatasource = (gridOptions) => {
		return {
			gridOptions,
			// called by the grid when more rows are required
			getRows: (params) => {
				// get data for request from server
				const payload = this.rootStore.getServerListPayload(
					params,
					this.searchValue
				);
				this.getList(payload)
					.then(({ data, totalRecords }) => {
						if (totalRecords === 0) {
							this.agGrid.api.showNoRowsOverlay();
						} else {
							this.agGrid.api.hideOverlay();
						}
						params.success({
							rowData: data,
							rowCount: totalRecords,
						});
					})
					.catch((err) => {
						params.fail(err);
					});
			},
		};
	};
	getList = async (payload) => {
		try {
			const { data } = await axios.get(
				`${API_URL.MERCHANT.LIST}?merchantId=&pageNo=${payload.pageNo}&pageSize=${payload.pageSize}&sortBy=${payload.sortBy}&searchValue=${encodeURIComponent(payload.searchValue)}&isActive=1`
			);
			return data.data;
		} catch {}
	};

	addMerchant = async (formData) => {
		return await axios
			.post(API_URL.MERCHANT.ADD, formData)
			.then(({ data }) => {
				if (!data.data.errorMessage) {
					// this.setupGrid(this.agGrid);
					return data;
				} else {
					return data.data.errorMessage;
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	addProperty = async (formData) => {
		return await axios
			.post(API_URL.ACCOMMODATION.ADD, formData)
			.then(({ data }) => {
				if (data.httpStatusCode === 200) {
					return data;
				} else {
					Notification.error({ message: data.message });
					return Promise.reject(data);
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	addRoomCategory = async (formData) => {
		return await axios
			.post(API_URL.ROOMCATEGORY.ADD, formData)
			.then(({ data }) => {
				return data;
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};
	getSubscriptionList = async () => {
		try {
			const { data } = await axios.get(`${API_URL.SUBSCRIPTION.LIST}`);
			this.subscriptionList = data.data;
			return data.data;
		} catch {}
	};

	getMerchantLookupList = async () => {
		try {
			const { data } = await axios.get(`${API_URL.ACCOMMODATION.LOOKUP}`);
			this.merchantLookupList = data.data;
			return data.data;
		} catch {}
	};

	EditMerchant = async (formData) => {
		return await axios
			.put(API_URL.MERCHANT.UPDATE, formData)
			.then(({ data }) => {
				// this.setupGrid(this.agGrid);
				if (data.httpStatusCode == 200) {
					return data;
				} else {
					return data.data;
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	ReadMerchant = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.MERCHANT.SINGLE + '?id=' + encodeURIComponent(id)
			);

			if (!data.data.errorMessage) {
				this.merchantDetail = data.data;
				return data.data;
			} else {
				this.merchantDetail = null;
				return false;
			}
		} catch {}
	};

	addMerchantSusbcription = async (formData) => {
		return await axios
			.post(API_URL.MERCHANTSUBSCRIPTION.ADD, formData)
			.then(({ data }) => {
				if (data.httpStatusCode === 200) {
					// this.setupGrid(this.agGrid);
					return data;
				} else {
					Notification.error({ message: data.message });
					return Promise.reject(data);
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	ReadSubscriptionHistory = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.SUBSCRIPTION.SINGLE + '?id=' + encodeURIComponent(id)
			);
			this.subscriptionHistory = data.data;
			return data.data;
		} catch {}
	};

	getMerchantAccomodation = async (id) => {
		try {
			const { data } = await axios.get(
				`${API_URL.ACCOMMODATION.LIST}?merchantId=${encodeURIComponent(id)}&pageNo=1&pageSize=1000&sortBy=propertyName%20asc&searchValue=&isActive=1`
			);
			this.merchantAccomodation = data.data.data;
			return data.data;
		} catch {}
	};

	EditProperty = async (formData) => {
		return await axios
			.put(API_URL.ACCOMMODATION.UPDATE, formData)
			.then(({ data }) => {
				if (data.httpStatusCode == 200) {
					return data;
				} else {
					return data.data;
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	EditRoomCategory = async (formData) => {
		return await axios
			.put(API_URL.ROOMCATEGORY.UPDATE, formData)
			.then(({ data }) => {
				// this.setupGrid(this.agGrid);
				if (data.httpStatusCode == 200) {
					return data;
				} else {
					return data.data;
				}
			})
			.catch(({ data }) => {
				return Promise.reject(data);
			});
	};

	ReadProperty = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.ACCOMMODATION.SINGLE + '?id=' + encodeURIComponent(id)
			);
			this.propertyDetail = data.data;
			return data.data;
		} catch {}
	};

	ReadRoomCategory = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.ROOMCATEGORY.SINGLE + '?id=' + encodeURIComponent(id)
			);
			this.roomCategoryDetail = data.data;
			return data.data;
		} catch {}
	};

	deleteProperty = async ({ id, versionNo }) => {
		try {
			const encodeURL =
				'?id=' + encodeURIComponent(id) + '&versionNo=' + versionNo;
			const { data } = await axios.delete(
				API_URL.ACCOMMODATION.DELETE + encodeURL
			);
			return data.message;
		} catch (err) {
			Promise.reject(err);
		}
	};

	deleteRoomCategory = async ({ id, versionNo }) => {
		try {
			const encodeURL =
				'?id=' + encodeURIComponent(id) + '&versionNo=' + versionNo;
			const { data } = await axios.delete(
				API_URL.ROOMCATEGORY.DELETE + encodeURL
			);
			return data.data;
		} catch (err) {
			Promise.reject(err);
		}
	};
	getRoomCategoryByProperty = async (id) => {
		try {
			const { data } = await axios.get(
				`${API_URL.ROOMCATEGORY.SINGLE}?id=${encodeURIComponent(id)}`
			);
			this.roomcategorybyproperty = data.data;
			return data.data;
		} catch {}
	};

	deleteMerchant = async ({ id, versionNo }) => {
		try {
			const encodeURL =
				'?id=' + encodeURIComponent(id) + '&versionNo=' + versionNo;
			const { data } = await axios.delete(
				API_URL.MERCHANT.DELETE + encodeURL
			);
			this.setupGrid(this.agGrid);
			return data.message;
		} catch (err) {
			Promise.reject(err);
		}
	};
	ReadPropertyImagedetail = async (formData) => {
		try {
			const { data } = await axios.get(`
				${API_URL.ACCOMMODATION.GETACCOMMODATIONIMAGE}?refTablename=${formData.tableName}&refId=${encodeURIComponent(formData.propertyID)}`);
			this.propertyImageDetails = data.data;
			return data.data;
		} catch {}
	};
	ReadRoomCategoryImagedetail = async (formData) => {
		try {
			const { data } = await axios.get(`
				${API_URL.ROOMCATEGORY.GETROOMCATEGORYIMAGE}?refTablename=${formData.tableName}&refId=${encodeURIComponent(formData.roomCategoryID)}`);
			this.roomCategoryImageDetails = data.data;
			return data.data;
		} catch {}
	};

	ReadRoomCategoryLookup = async (id) => {
		try {
			const { data } = await axios.get(
				API_URL.ROOMCATEGORY.ROOMCATEGORYLOOKUP +
					'?propertyid=' +
					encodeURIComponent(id)
			);
			this.roomCategoryLookup = data.data;
			return data.data;
		} catch {}
	};
}
